import { render, staticRenderFns } from "./BookingSlots.vue?vue&type=template&id=0eee86f4&"
import script from "./BookingSlots.vue?vue&type=script&lang=js&"
export * from "./BookingSlots.vue?vue&type=script&lang=js&"
import style0 from "./BookingSlots.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VAvatar,VContainer,VDataTable,VPagination})
